/**
 * 🔒 Saves text as a file through the browser (decision 5981; T3484): the match log's CSV and JSON and the Compare
 * screen's Zoho Books answers go out the same way. A test double carries no object URL; the browser always does.
 */
export function saveTextFile(filename: string, type: string, text: string): void {
  if (typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') return;
  const url = URL.createObjectURL(new Blob([text], { type }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
